<h1 class="u-sr-only">{{ 'Profile.Menu.Bookings' | translate }}</h1>
<section class="c-section c-section--first c-section--last c-section--open c-section--static u-no-pb">
	<div class="c-section__header" [ngClass]="{'u-hidden@md-and-up': vm.isDoctor}">
		<h2 class="c-section__title" *ngIf="vm.isDoctor">{{ vm.bookingsType === 'instant' ? ('Booking.Instant.Title' | translate) : vm.activeTab?.label }}</h2>
		<h1 class="c-section__title c-section__title--sm" *ngIf="!vm.isDoctor">{{ (vm.activeTab?.id === 'upcoming' || vm.activeTab?.id === 'history' ? 'Profile.Menu.My_Bookings' : 'Sidebar.Menu.My_Tickets') | translate }}</h1>
		<h2 class="c-section__title u-hidden@md-and-up" *ngIf="!vm.isDoctor">{{ vm.activeTab?.label }}</h2>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<div class="c-card">
					<div class="c-content u-hidden@up-to-md">
						<div class="o-grid o-grid--center-v">
							<div class="o-grid__cell o-grid__cell--slim u-no-pl">
								<div class="c-tabs u-no-mb">
									<a id="selectTab-{{tab.id}}" [attr.data-testid]="'booking-tab-' + tab.id" (click)="vm.selectTab(tab)" style="cursor:pointer;" class="c-tabs__link c-tabs__link--sm"
										 [ngClass]="{'c-tabs__link--active': vm.bookingsType === tab.id, 'c-tabs__link--w-badge': (tab.status === 'PAYED' && tab.unconfirmedBookingsCount > 0) ||
      										(tab.id === 'request' && tab.unansweredRequestsCount > 0)}"
										 *ngFor="let tab of vm.tabs">
										{{ tab.label }}<span class="c-badge c-badge--s2" *ngIf="tab.status === 'PAYED' && tab.unconfirmedBookingsCount">{{ tab.unconfirmedBookingsCount }}</span>
										<span class="c-badge c-badge--s2" *ngIf="tab.id === 'request' && tab.unansweredRequestsCount > 0">{{ tab.unansweredRequestsCount }}</span>
									</a>
								</div>
							</div>
							<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-fixed u-no-pr" *ngIf="vm.isDoctor && (vm.bookingsType === 'unconfirmed' || vm.bookingsType === 'upcoming' || vm.bookingsType === 'service-provider-pre-visit')">
								<div class="c-form__group--icon u-no-pb">
									<i class="o-icon o-icon--search c-form__icon" aria-hidden="true"></i>
									<input id="searchUserInput" type="text" class="c-form__input c-form__input--sm" placeholder="{{ 'Services.Other.Search_Placeholder' | translate }}" spellcheck="false" [(ngModel)]="vm.nameFilter" [ngModelOptions]="{ debounce: 500 }">
								</div>
							</div>
							<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-fixed u-no-pr">
								<a id="avTestButton" href="{{ vm.avTestUrl }}" class="c-button c-button--s2">{{ 'How_It_Works.Item5-2' | translate }}</a>
							</div>
						</div>
						<div class="o-grid o-grid--center-v o-grid--center-h">
							<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-fixed u-no-pr" *ngIf="vm.isDoctor && vm.bookingsType === 'history'">
								<div class="c-form__group--icon u-no-pb">
									<i class="o-icon o-icon--search c-form__icon" aria-hidden="true"></i>
									<input id="searchUserNameInput" type="text" class="c-form__input c-form__input--sm" placeholder="{{ 'Services.Other.Search_Placeholder' | translate }}" spellcheck="false" [(ngModel)]="vm.nameFilter" [ngModelOptions]="{ debounce: 500 }">
								</div>
							</div>
							<div class="o-grid__cell o-grid__cell--w-16 o-grid__cell--slim u-no-pr" *ngIf="vm.isDoctor && vm.bookingsType === 'history'">
								<div class="c-form__group u-no-m">
									<mat-select id="searchBookingByStatusSelect" [(value)]="vm.bookingStatusFilter" class="mat-select mat-select--sm mat-select--border" placeholder="{{'Services.Other.Search_By_Status_Placeholder' | translate}}">
										<mat-option id="bookingStatus{{$index}}" *ngFor="let status of vm.bookingsStatus ; let $index=index" [value]="status">{{ 'Calendar.Modal.' + status | translate }}</mat-option>
									</mat-select>
								</div>
							</div>
							<div class="o-grid__cell o-grid__cell--w-20 o-grid__cell--slim u-no-pr" style="margin-top: 10px;" *ngIf="vm.isDoctor && vm.bookingsType === 'history'">
								<div class="c-form__group c-form__group--icon u-osb-sm">
									<i class="o-icon o-icon--schedule c-form__icon" aria-hidden="true"></i>
									<input-datepicker-new id="{{ 'bookingFilterDateRange-1'  }}"
														  [(model)]="vm.dateRangeModel"
														  [hasTimepicker]="false"
														  [hasCalendarIcon]="false"
														  [minDate]="vm.minDate"
														  [isSmall]="true"
														  [isSingleDate]="false"
														  [isRequired]="false"></input-datepicker-new>
								</div>
							</div>
						</div>
					</div>
					<div class="c-content u-hidden@md-and-up c-booking-history-filters" *ngIf="vm.isDoctor && vm.bookingsType === 'history'">
						<div class="o-grid o-grid--wrap">
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--right u-no-p" style="margin-top: 10px;">
								<div class="c-form__group c-form__group--icon u-osb-sm">
									<i class="o-icon o-icon--schedule c-form__icon" aria-hidden="true"></i>
									<input-datepicker-new id="{{ 'bookingFilterDateRange-1'  }}"
														  [(model)]="vm.dateRangeModel"
														  [hasTimepicker]="false"
														  [hasCalendarIcon]="false"
														  [minDate]="vm.minDate"
														  [isSmall]="true"
														  [isSingleDate]="false"
														  [isRequired]="false"></input-datepicker-new>
								</div>
							</div>
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--left u-no-p">
								<div class="o-grid c-booking-history-filters__search-row">
									<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 u-no-p c-booking-history-filters__name">
										<div class="c-form__group--icon u-no-pb">
											<i class="o-icon o-icon--search c-form__icon" aria-hidden="true"></i>
											<input id="searchUserNameInputMobile" type="text" class="c-form__input c-form__input--sm" placeholder="{{ 'Services.Other.Search_Placeholder' | translate }}" spellcheck="false" [(ngModel)]="vm.nameFilter" [ngModelOptions]="{ debounce: 500 }">
										</div>
									</div>
									<div class="o-grid__cell o-grid__cell--slim o-grid__cell--fixed u-no-p c-booking-history-filters__status" style="margin-left: 10px;">
										<div class="c-form__group u-no-m">
											<mat-select id="searchBookingByStatusSelectMobile" [(value)]="vm.bookingStatusFilter" class="mat-select mat-select--sm mat-select--border" placeholder="{{'Services.Other.Search_By_Status_Placeholder' | translate}}">
												<mat-option id="bookingStatusMobile{{$index}}" *ngFor="let status of vm.bookingsStatus ; let $index=index" [value]="status">{{ 'Calendar.Modal.' + status | translate }}</mat-option>
											</mat-select>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<content [ngSwitch]="vm.bookingsType">
						<div *ngSwitchCase="'instant'">					
							<card-bookings-instant></card-bookings-instant>
						</div>
						<div *ngSwitchCase="'pre-visit'">	
							<pre-visit-history [tabs]="vm.tabs" [activeTab]="vm.activeTab"></pre-visit-history>
						</div>
						<div *ngSwitchCase="'service-provider-pre-visit'">	
							<service-provider-pre-visit-history [tabs]="vm.tabs" [activeTab]="vm.activeTab" [nameFilter]="vm.nameFilter"></service-provider-pre-visit-history>
						</div>
						<div *ngSwitchCase="'request'">
							<card-booking-requests [requests]="vm.bookingRequests"></card-booking-requests>
						</div>
						<div *ngSwitchDefault>
							<ng-container *ngIf="vm.readyForBookings">				
								<card-bookings [tabs]="vm.tabs" [activeTab]="vm.activeTab" [nameFilter]="vm.nameFilter" [bookingStatusFilter]="vm.bookingStatusFilter" [dateRangeModel]="vm.dateRangeModel"></card-bookings>
							</ng-container>
						</div>
					</content>
				</div>
			</div>
		</div>
	</div>
</section>
